module.exports = __webpack_public_path__ + "img/option3.36aa7de0.jpeg";